/**
 * เปิดหน้าพิมพ์/รายงานของ admission2017 ที่บังคับ JWT
 * (แท็บใหม่ส่ง Authorization header ไม่ได้ — แนบ access_token ใน query)
 */

export function admissionAccessToken() {
  try {
    return localStorage.getItem("token") || "";
  } catch {
    return "";
  }
}

/** path ที่โดน RequireInternalAuth / RequirePartnerAuth */
function needsAccessToken(url) {
  const u = String(url || "");
  if (!u) return false;
  if (/[?&]access_token=/.test(u)) return false;
  return (
    /\/dashboard_/i.test(u) ||
    /\/administrator_/i.test(u) ||
    /\/faculty_/i.test(u) ||
    /\/finance/i.test(u) ||
    /printregistrar/i.test(u) ||
    /printbill/i.test(u) ||
    /printlist/i.test(u)
  );
}

export function withAccessToken(url) {
  const token = admissionAccessToken();
  if (!token || !url) return url;
  if (!needsAccessToken(url)) return url;
  const sep = String(url).includes("?") ? "&" : "?";
  return `${url}${sep}access_token=${encodeURIComponent(token)}`;
}

export function openAdmissionPrint(url, target = "_blank") {
  return window.open(withAccessToken(url), target);
}
